'use client';

import React, { useState, useEffect } from 'react';
import { Lightbulb, Info } from 'lucide-react';

export default function KomSuggestionsHeader() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="px-6 py-4 border-b border-[hsl(var(--border))] bg-white shrink-0">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
            <Lightbulb size={16} className="text-amber-500" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-[hsl(var(--foreground))]">KOM Segment Suggestions</h1>
            <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
              Portions of your activities where you recorded the fastest known time — but no official segment exists yet
            </p>
          </div>
        </div>
        {mounted && (
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-amber-50 border border-amber-100 text-[11px] text-amber-700 font-medium shrink-0">
            <Info size={11} />
            <span>Based on your Strava activity data</span>
          </div>
        )}
      </div>
    </div>
  );
}
